import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[blackConfirmDialogTrigger]',
  standalone: false,
})
export class ConfirmDialogTriggerDirective {  templateRef = inject<TemplateRef<any>>(TemplateRef);

}
